import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import gql from 'graphql-tag';
export var SellerQuestionEnabledQuery = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  query seller($questionSellerId: String) {\n    sellerQuestions: seller(sellerId: $questionSellerId) {\n      enabled\n    }\n  }\n"])));